/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetPLForUserByAccountOptions,
  GetPLForUserByAccountStatus200,
  GetPLForUserByAccountStatus401,
  GetPLForUserByAccountStatus404,
  GetPLForUserByAccountStatus500,
} from '../types/GetPLForUserByAccount'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getPLForUserByAccount } from '../clients/getPLForUserByAccount'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getPLForUserByAccountQueryKey = ({
  path,
}: Omit<GetPLForUserByAccountOptions, 'headers'>) =>
  [{ url: '/v1/pl/:user_id', params: path }] as const

type GetPLForUserByAccountQueryKey = ReturnType<typeof getPLForUserByAccountQueryKey>

export function getPLForUserByAccountQueryOptions(
  { path }: GetPLForUserByAccountOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getPLForUserByAccountQueryKey({ path })
  return queryOptions<
    GetPLForUserByAccountStatus200,
    ResponseErrorConfig<
      | GetPLForUserByAccountStatus401
      | GetPLForUserByAccountStatus404
      | GetPLForUserByAccountStatus500
    >,
    GetPLForUserByAccountStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getPLForUserByAccount({
        ...config,
        path,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get account-by-account PL breakdown for a user
 * {@link /v1/pl/:user_id}
 */
export function useGetPLForUserByAccount<
  TData = GetPLForUserByAccountStatus200,
  TQueryData = GetPLForUserByAccountStatus200,
  TQueryKey extends QueryKey = GetPLForUserByAccountQueryKey,
>(
  {
    path,
  }: { path: GetPLForUserByAccountOptions['path'] | (() => GetPLForUserByAccountOptions['path']) },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetPLForUserByAccountStatus200,
        ResponseErrorConfig<
          | GetPLForUserByAccountStatus401
          | GetPLForUserByAccountStatus404
          | GetPLForUserByAccountStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path }
  const queryKey = resolvedOptions?.queryKey ?? getPLForUserByAccountQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getPLForUserByAccountQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetPLForUserByAccountStatus401
      | GetPLForUserByAccountStatus404
      | GetPLForUserByAccountStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
